import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { debounceTime, distinctUntilChanged, Subscription } from 'rxjs';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatSelectChange } from '@angular/material/select';
import { ServiceInfoClientService } from '../../../files-clients/service/service-info-client.service';
import { ActionDeals } from '../../../clients/interface/data.interface';

@Component({
  selector: 'app-filter-table-deals',
  templateUrl: './filter-table-deals.component.html',
  styleUrls: ['./filter-table-deals.component.scss']
})
export class FilterTableDealsComponent {
  @Output() filters = new EventEmitter<{ search: string, finalidad: string, start: Date, end: Date, estado: string, estadoActiviti: number, nameAccion: string, etiqueta: string }>();
  public currentDate = new Date();
  public selectFilters: Array<any>;
  public selectFiltersFinalidad: Array<any>;
  public selectFiltersEstadoDeal: Array<any>;
  public selectFiltersEstadoActiviti: Array<any>;
  public selectFiltersAccion: ActionDeals[] = [];
  public filterForm: FormGroup;
  public searchSubscription: Subscription;
  public tags: string[] = [];

  constructor(private fb: FormBuilder, private infoService: ServiceInfoClientService){
    this.filterForm  = this.fb.group({
      dateRange: 1,
      start: null,
      end: null,
      search: '',
      finalidad: '',
      estado: '',
      estadoActiviti: 0,
      estadoAccion: '',
      etiqueta: ''
    });

   this.setSelectFiltersFinalidad();
   this.setSelectFiltersEstadoDeal();
   this.setSelectFiltersEstadoAction();
  }

  ngOnInit(): void {
    this.getDealsTags();
    this.getDealsActions();
    this.searchSubscription = this.filterForm.controls['search'].valueChanges
    .pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe(() => {
      this.sendFilters();
    })
  }

  setSelectFiltersFinalidad():void {
    this.selectFiltersFinalidad = [
      { value: '', text: 'Todas' },
      { value: 'Fiel Cumplimiento', text: 'Fiel Cumplimiento' },
      { value: 'Seriedad de Oferta', text: 'Seriedad de Oferta' },
      { value: 'Emisión Factoring', text: 'Emisión Factoring' },
      { value: 'Correcta Ejecución', text: 'Correcta Ejecución' },
    ];
  }

  setSelectFiltersEstadoDeal() {
    this.selectFiltersEstadoDeal = [
      { value: '', text: 'Abiertos' },
      { value: 'Ganado', text: 'Ganados' },
      { value: 'Perdido', text: 'Perdidos' }
    ];
  }

  setSelectFiltersEstadoAction() {
    this.selectFiltersEstadoActiviti = [
      { value: 0, text: 'Pendientes' },
      { value: 1, text: 'Aprobados' },
      { value: 2, text: 'Rechazados' },
      { value: 3, text: 'Pendientes de Informacion' }
    ];
  }

  public changeFilterSelect(change: MatSelectChange):void {
    const { value } = change;
    //this.setDateRangeFromSelect(value);
    this.sendFilters();
  }

  changeDateInput(event: MatDatepickerInputEvent<Date>) {
    const {start, end } = this.filterForm.value;
    if(start && end){
      this.filterForm.patchValue({dateRange: 0});
      this.sendFilters();
    }
  }

  applyDateRangePicker() {
    /*this.filterForm.patchValue({
      dateRange: 0
    });*/
    this.sendFilters();
  }

  resetDateRangePicker() {
    this.filterForm.get('start')?.reset();
    this.filterForm.get('end')?.reset();
    this.sendFilters();
  }

  public sendFilters(): void {
    const {start, end, search, finalidad, estado, estadoActiviti, estadoAccion, etiqueta} = this.filterForm.value;
    this.filters.emit({ search: search, finalidad: finalidad, start: start, end: end, estado: estado, estadoActiviti: estadoActiviti, nameAccion: estadoAccion, etiqueta: etiqueta });
  }

  public onSearch() {
    const searchTerm = this.filterForm.get('search')?.value;
    this.filters.emit(searchTerm);
  }

  public ngOnDestroy(): void {
      this.searchSubscription.unsubscribe();
  }

  public getDealsTags() {
    this.infoService.getDealsTags().subscribe({
      next: (res: string[]) => {
        this.tags = res;
      },
      error: (err) => {
        console.log(err);
      }
    });
  }

  public getDealsActions() {
    this.infoService.getDealsActions().subscribe({
      next: (res) => {
        this.selectFiltersAccion = res;
      },
      error: (err) => {
        console.log(err);
      }
    });
  }

}
